import { action, makeObservable, observable } from 'mobx';

class UserSettingsStore {
  isTurboOn = false;

  isMusicOn = true;

  isSoundOn = true;

  isBoostedJackpotInitialPopup = true;

  isHotKeyEnable = false;

  zoomValue = 1;

  isShowMusicIcon = true;

  isNumpadActive = false;

  isShowSoundIcon = true;

  isShowTurboIcon = true;

  isFullScreen = false;

  allowFullScreen = true;

  constructor() {
    makeObservable(this, {
      isMusicOn: observable,
      isSoundOn: observable,
      isTurboOn: observable,
      isBoostedJackpotInitialPopup: observable,
      zoomValue: observable,
      isFullScreen: observable,
      isHotKeyEnable: observable,
      isNumpadActive: observable,
      isShowMusicIcon: observable,
      isShowSoundIcon: observable,
      isShowTurboIcon: observable,
      allowFullScreen: observable,
      setIsMusicOn: action.bound,
      setIsSoundOn: action.bound,
      updateIsBoostedJackpotInitialPopup: action.bound,
      setIsBoostedJackpotInitialPopup: action.bound,
      setZoomValue: action.bound,
      setIsTurboOn: action.bound,
      setIsFullScreen: action.bound,
      toggleFullscreen: action.bound,
      setAllowFullScreen: action.bound,
      setIsShowTurboIcon: action.bound,
      setIsShowSoundIcon: action.bound,
      setIsNumpadActive: action.bound,
      setIsShowMusicIcon: action.bound,
      setIsHotKeyEnable: action.bound,
      updateNewBoostedJackpotById: action.bound,
      localStorageAndUserSettingsInit: action.bound,
    });
  }

  toggleFullscreen() {
    !this.isFullScreen ? this.openFullScreen() : this.closeFullScreen();
  }

  setIsFullScreen(bool) {
    this.isFullScreen = bool;
  }

  setAllowFullScreen(bool) {
    this.allowFullScreen = bool;
  }

  setIsShowTurboIcon(bool) {
    this.isShowTurboIcon = bool;
  }

  setZoomValue(value) {
    this.zoomValue = value;
  }

  setIsShowSoundIcon(bool) {
    this.isShowSoundIcon = bool;
  }

  setIsNumpadActive(bool) {
    this.isNumpadActive = bool;
  }

  setIsShowMusicIcon(bool) {
    this.isShowMusicIcon = bool;
  }

  setIsHotKeyEnable(bool) {
    this.isHotKeyEnable = bool;
  }

  updateLocalStorage(updatedSettings) {
    if (localStorage.getItem(this.localStorageKey)) {
      const updatedUserSettings = {
        ...JSON.parse(localStorage.getItem(this.localStorageKey)),
        ...updatedSettings,
      };
      localStorage.setItem(this.localStorageKey, JSON.stringify(updatedUserSettings));
    }
  }

  localStorageAndUserSettingsInit({ gameName: gamePrefix }) {
    this.localStorageKey = gamePrefix;
    const userSettings = JSON.parse(localStorage.getItem(this.localStorageKey));
    const defSettings = {
      isMusicOn: this.isMusicOn,
      isSoundOn: this.isSoundOn,
      isTurboOn: this.isTurboOn,
      isBoostedJackpotInitialPopup: this.isBoostedJackpotInitialPopup,
      boostedJackpotId: null,
    };
    if (
      userSettings === null ||
      Object.keys(defSettings).length !== Object.keys(userSettings).length
    ) {
      localStorage.setItem(this.localStorageKey, JSON.stringify(defSettings));
    } else {
      const { isMusicOn, isSoundOn, isTurboOn, isBoostedJackpotInitialPopup } = userSettings;
      this.isMusicOn = isMusicOn;
      this.isSoundOn = isSoundOn;
      this.isTurboOn = isTurboOn;
      this.isBoostedJackpotInitialPopup = isBoostedJackpotInitialPopup;
    }
  }

  updateNewBoostedJackpotById(id) {
    const localStorageData = JSON.parse(localStorage.getItem(this.localStorageKey));
    if (localStorageData && localStorageData.boostedJackpotId !== id) {
      this.updateLocalStorage({
        boostedJackpotId: id,
        isBoostedJackpotInitialPopup: true,
      });
      this.isBoostedJackpotInitialPopup = true;
    }
  }

  setIsMusicOn() {
    this.updateLocalStorage({
      isMusicOn: !this.isMusicOn,
    });
    this.isMusicOn = !this.isMusicOn;
  }

  setIsTurboOn() {
    this.updateLocalStorage({
      isTurboOn: !this.isTurboOn,
    });
    this.isTurboOn = !this.isTurboOn;
  }

  setIsSoundOn() {
    this.updateLocalStorage({
      isSoundOn: !this.isSoundOn,
    });
    this.isSoundOn = !this.isSoundOn;
  }

  updateIsBoostedJackpotInitialPopup() {
    this.updateLocalStorage({
      isBoostedJackpotInitialPopup: !this.isBoostedJackpotInitialPopup,
    });
    this.isBoostedJackpotInitialPopup = !this.isBoostedJackpotInitialPopup;
  }

  setIsBoostedJackpotInitialPopup(bool) {
    this.updateLocalStorage({
      isBoostedJackpotInitialPopup: bool,
    });
    this.isBoostedJackpotInitialPopup = bool;
  }

  openFullScreen() {
    const htmlElement = window.document.documentElement;
    switch (true) {
      case !!htmlElement.requestFullscreen:
        htmlElement.requestFullscreen();
        break;
      case !!htmlElement.mozRequestFullScreen /* Firefox */:
        htmlElement.mozRequestFullScreen();
        break;
      case !!htmlElement.webkitRequestFullscreen /* Chrome, Safari and Opera */:
        htmlElement.webkitRequestFullscreen();
        break;
      case !!htmlElement.msRequestFullscreen /* IE/Edge */:
        htmlElement.msRequestFullscreen();
        break;
      default:
        break;
    }
  }

  closeFullScreen() {
    const { document } = window;
    switch (true) {
      case !!document.exitFullscreen:
        document?.exitFullscreen();
        break;
      case !!document.mozCancelFullScreen /* Firefox */:
        document.mozCancelFullScreen();
        break;
      case !!document.webkitExitFullscreen /* Chrome, Safari and Opera */:
        document.webkitExitFullscreen();
        break;
      case !!document.msExitFullscreen /* IE/Edge */:
        document.msExitFullscreen();
        break;
      default:
        break;
    }
  }
}

export const userSettingsStore = new UserSettingsStore();
